<template>
  <!-- KMA 연수 교육 영역 -->
  <div class="kma-edu-wrap">
    <h2 @click="$router.push({ name: 'app-webseminar-kma' })">
      KMA 연수 교육
    </h2>
    <div class="kma-edu-tb">
      <table>
        <colgroup>
          <col style="width: 188px">
          <col style="width: 100px">
          <col style="width: 320px">
          <col style="width: 160px">
          <col style="width: 50px">
        </colgroup>
        <thead>
          <tr>
            <th>교육일시</th>
            <th>기관명</th>
            <th>교육명</th>
            <th>장소</th>
            <th>평점</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="kmaList.length === 0">
            <td colspan="5">
              <p class="empty-kma">
                예정된 연수 교육이 없습니다.
              </p>
            </td>
          </tr>
          <tr v-for="(item, i) in kmaList" v-else :key="i">
            <td>{{ getStartDateTime(item.startDate, item.startTime, item.endTime) }}</td>
            <td>{{ item.organization }}</td>
            <td class="ellipsis-txt"
                style="text-decoration: underline; cursor: pointer;"
                @click.prevent="linkKmaSeminar(item)"
            >
              {{ item.title }}
            </td>
            <td>{{ item.place }}</td>
            <td>{{ item.gradepoint.split(' ')[1] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- //KMA 연수 교육 영역 -->
</template>

<script>
import axios from '@axios'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import { setStatisticsNew } from '@/common/statistics/service'
import { SNT } from '@/core/global/global-enums'
import { callExternalApi } from '@/core/global/global-liveinfo'

export default {
  data() {
    return {
      // KMA 연수 교육 관련 데이터
      kmaList: [],
    }
  },
  computed: {
    ...mapGetters({
      medicalDept: 'infoData/getMedicalDept',
    })
  },
  watch: {
    medicalDept: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.doSearchKma()
      }
    }
  },
  // mounted() {
  //   this.doSearchKma()
  // },
  methods: {
    linkKmaSeminar(item) {
      const eduKmaUrl = 'https://edu.kma.org/edu/schedule_view'

      setStatisticsNew(
        SNT.A.Service_컨텐츠__웹세미나_KMA연수교육,
        SNT.B.Position_닥터인포__메인____Body____웹세미나_My세미나_컨텐츠목록,
        SNT.C.State_Action__클릭_컨텐츠,
        item.kmaSeminarId
      ) // KMA 연수교육 통계 집계

      callExternalApi("LinkUrl", `${eduKmaUrl}?eduidx=${item.kmaSeminarId}`)
    },
    doSearchKma() {
      axios.post("/fu/dashboard/kma", {
        CondDeptCodes: this.medicalDept || 0,
      })
        .then(async rs => {
          this.kmaList = rs.data
        })
        .catch(error => {
          this.showAlertDialog(error.response.data)
        })
    },
    getStartDateTime(starDate, startTime, endTime) {
      const dayOfWeek = dayjs(starDate).format('d')
      const date = dayjs(starDate).format('YYYY-MM-DD')

      if (startTime && endTime) {
        return `${date} (${this.getDayOfWeekName(dayOfWeek)}) ${startTime} ~ ${endTime}`
      }

      return `${date} (${this.getDayOfWeekName(dayOfWeek)})`
    },
    getDayOfWeekName(dayOfWeek) {
      if (dayOfWeek === '0') { return '일' }
      if (dayOfWeek === '1') { return '월' }
      if (dayOfWeek === '2') { return '화' }
      if (dayOfWeek === '3') { return '수' }
      if (dayOfWeek === '4') { return '목' }
      if (dayOfWeek === '5') { return '금' }
      if (dayOfWeek === '6') { return '토' }
      return ''
    },
  },
}
</script>
